import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel
} from '@material-ui/core';
import { useDeleteTrainingGroups } from '../Training.hooks';
import { Training } from '../Training.interface';

export interface TrainingDeleteGroupDialogProps {
  open: boolean;
  onClose?: () => void;
  onDelete?: () => void;
  training: Training;
  selectedGroups: number[];
}

const TrainingDeleteGroupDialog: React.FC<TrainingDeleteGroupDialogProps> = ({
  open,
  onClose,
  onDelete,
  training,
  selectedGroups
}) => {
  const [checked, setChecked] = useState(false);
  const { deletedGroups, error, isDeleting, del } = useDeleteTrainingGroups(
    training.id
  );
  const onDeleteRef = useRef(onDelete);

  useEffect(() => {
    if (!isDeleting && deletedGroups && onDeleteRef && onDeleteRef.current) {
      onDeleteRef.current();
    }
  }, [deletedGroups, isDeleting, error]);

  function handleDelete() {
    del({ deleteUsers: checked, groupIds: selectedGroups.join(',') });
  }

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete this group from training?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleCheck}
                name='checked'
                color='default'
              />
            }
            label='Delete all assigned users from this group for the current training
            version?'
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleDelete} variant='contained' color='primary'>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrainingDeleteGroupDialog;
